import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
// import './styles.less'
import ProjectNameWidget from '../../../widgets/projectProposal/project/ProjectNameWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getProjectName, getSubProjectName } from '../../../redux/actions/projectName'
import { getProgressiveFormDate } from '../../../redux/actions/progressiveReport'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ProgressiveSubProjectWidget from '../../../widgets/progressiveSubProject/ProgressiveSubProjectWidget'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import { Row, Panel } from 'rsuite'
import moment from 'moment'
import { DATE_FORMAT } from '../../../constants/date'

export default function SaveProgressive() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const dateNow = moment().format(DATE_FORMAT)

  useEffect(() => {
    // console.log('load ProjectName projectId', dateNow, projectId)

    handleGetSchema(projectId, dateNow)
  }, [])

  const handleGetSchema = async (projectId, date) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProgressiveFormDate(projectId, date)
      console.log('res ', _schema)
      setSchema(_schema.forms)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      <div className="custom-dashboard">
        <TopLevelNav />
        <PageToolbar />
        <Row style={{ marginBottom: 30, marginTop: 30 }}>
          {schema?.projectInfo && (
            <>
              <ProjectBasicInfo schema={schema.projectInfo} />
              <br />
            </>
          )}

          {schema.subProjectList && (
            <>
              <ProgressiveSubProjectWidget schema={schema.subProjectList} />
            </>
          )}
        </Row>
      </div>
    </>
  )
}
